module.exports = __webpack_public_path__ + "img/farmer-lg.c201ef9a.png";